function getMessage(message, defaultMsg, params, conjunction) {
  const listString = conjunction
    ? `${params.slice(0, -1).join(', ')} ${conjunction} ${params.slice(-1)}`
    : params;

  if (message) {
    return `${message} ${listString}.`;
  }
  return `${defaultMsg} ${listString}.`;
}

function validateIncludeAny(input, includeAny) {
  return !!includeAny.find((o) => input.includes(o));
}

function validateIncludeAll(input, includeAll) {
  return includeAll.filter((o) => input.includes(o)).length === includeAll.length;
}

function validateExcludeAny(input, excludeAny) {
  return excludeAny.filter((o) => !input.includes(o)).length !== 0;
}

function validateExcludeAll(input, excludeAll) {
  return excludeAll.filter((o) => input.includes(o)).length === 0;
}

function wildCardValidator({ configs, input, msgs }) {
  let startsWith;
  let endsWith;
  let includeAny;
  let includeAll;
  let excludeAny;
  let excludeAll;

  if (configs) {
    startsWith = configs.startsWith ? configs.startsWith : undefined;
    endsWith = configs.endsWith ? configs.endsWith : undefined;
    includeAny = configs.includeAny ? configs.includeAny.split(';') : undefined;
    includeAll = configs.includeAll ? configs.includeAll.split(';') : undefined;
    excludeAny = configs.excludeAny ? configs.excludeAny.split(';') : undefined;
    excludeAll = configs.excludeAll ? configs.excludeAll.split(';') : undefined;
  }
  if (startsWith && !input.startsWith(startsWith)) {
    return getMessage(msgs.startsWith, 'Value needs to start with ', startsWith);
  }
  if (endsWith && !input.endsWith(endsWith)) {
    return getMessage(msgs.endsWith, 'Value needs to end with ', endsWith);
  }
  if (includeAny && validateIncludeAny(input, includeAny) === false) {
    return getMessage(msgs.includeAny, 'Value needs to include', includeAny, 'or');
  }
  if (includeAll && validateIncludeAll(input, includeAll) === false) {
    return getMessage(msgs.includeAll, 'Value needs to include', includeAll, 'and');
  }
  if (excludeAny && validateExcludeAny(input, excludeAny) === false) {
    return getMessage(msgs.excludeAny, 'Value needs to exclude', excludeAny, 'or');
  }
  if (excludeAll && validateExcludeAll(input, excludeAll) === false) {
    return getMessage(msgs.excludeAll, 'Value needs to exclude', excludeAll, 'and');
  }
  return null;
}

export default wildCardValidator;
